/* ★ POPUP "CARD TIADA PROMPT" — Run Flow DITAHAN (keputusan user 2026-09-18).
 *
 * Muncul bila satu atau lebih card yang ditanda tiada prompt yang robot Flow perlukan untuk set /
 * babak yang akan dijalankan. Tanpa semakan ini robot menggantikan prompt kosong dengan NAMA PRODUK
 * dan terus menjana (kredit terbakar, hasil tidak menjadi, tiada sebab pada card).
 * Aturan user: TIADA automation dijalankan langsung — sama seperti tab My Agent. Card terlibat turut
 * ditanda oren dalam senarai (WorkspaceView); tanda itu hilang sendiri bila card tidak lagi menahan
 * larian (prompt diisi · tick card / set dibuang · Run ditekan semula).
 *
 * TEKS SAHAJA. Rupa dikongsi: PopupRunDitahan. Semakan + ayat baris: utils/semakPromptFlow.js.
 * senarai: [{ id, nama, masalah }] — `masalah` = hasil `masalahPromptKad` semasa Run ditekan.
 */
import React from 'react';
import PopupRunDitahan from './PopupRunDitahan';
import { ringkasMasalahPrompt } from '../utils/semakPromptFlow';

export default function PopupPromptKosongFlow({ senarai, onTutup, T }) {
    if (!Array.isArray(senarai) || senarai.length === 0) return null;

    const n = senarai.length;
    const baris = senarai.map((k) => ({ id: k.id, nama: k.nama, ringkas: ringkasMasalahPrompt(k.masalah, T) }));
    /* FLOWNITY / dinamik: babak kosong DILANGKAU skrip (bukan nama produk), jadi sebabnya lain.
       Satu larian = satu jenis skrip (pagar campuran module dalam Run Flow), jadi tiada campuran. */
    const babakSahaja = baris.every((b) => b.ringkas.babakSahaja);

    return (
        <PopupRunDitahan
            ikon="speaker_notes_off"
            idTajuk="ppk-tajuk"
            tajuk={n === 1
                ? T('ws.flowPrompt.tajuk1', '1 card tiada prompt')
                : T('ws.flowPrompt.tajuk', `${n} card tiada prompt`, { n })}
            sebab={babakSahaja
                ? T('ws.flowPrompt.sebabBabak', 'Flow perlukan prompt untuk setiap babak. Babak tanpa prompt akan dilangkau, jadi video akhir tidak lengkap.')
                : T('ws.flowPrompt.sebab', 'Flow perlukan prompt untuk setiap set yang dijalankan. Tanpa prompt, robot terpaksa guna nama produk sahaja — hasilnya tidak menjadi dan kredit Flow terbakar.')}
            senarai={baris.map((b) => ({ id: b.id, nama: b.nama, keterangan: b.ringkas.baris }))}
            caraTajuk={T('ws.flowPrompt.caraTajuk', 'Cara betulkan')}
            cara={[
                T('ws.flowPrompt.cara1', 'Isi prompt yang kosong — Generate semula card itu, atau tampal prompt sendiri.'),
                T('ws.flowPrompt.cara2', 'Atau buang tick pada card itu, atau buang tick set itu di Control Panel.'),
                T('ws.flowPrompt.cara3', 'Tekan Run semula.'),
            ]}
            nota={T('ws.flowPrompt.tiadaJalan', 'Tiada automation dijalankan.')}
            butang={T('ws.flowPrompt.faham', 'Faham')}
            onTutup={onTutup}
            T={T}
        />
    );
}
